// extracted by mini-css-extract-plugin
export default {"container":"SpecialOfferSection_container__x8DMn"};